import React from 'react';
export function Footer() {
  return <footer className="bg-[#050D05] py-12 border-t border-gray-900" data-id="element-54">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-55">
        <h2 className="text-3xl font-black tracking-tighter text-white mb-6 opacity-50" data-id="element-56">
          VARAMAX
        </h2>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-gray-500" data-id="element-57">
          <a href="#" className="hover:text-[#FF6B00] transition-colors" data-id="element-58">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#FF6B00] transition-colors" data-id="element-59">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-[#FF6B00] transition-colors" data-id="element-60">
            Contacto
          </a>
          <a href="#" className="hover:text-[#FF6B00] transition-colors" data-id="element-61">
            Afiliados
          </a>
        </div>

        <p className="text-xs text-gray-600 max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-62">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          pueden variar de persona a persona. Todos los testimonios son reales
          pero no garantizan resultados específicos.
        </p>

        <p className="text-xs text-gray-700" data-id="element-63">
          © {new Date().getFullYear()} Varamax. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}